/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IndexDocumentFromJSON, IndexDocumentToJSON } from './IndexDocument';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetDocumentsResponseDataFromJSON(json) {
    return GetDocumentsResponseDataFromJSONTyped(json, false);
}
export function GetDocumentsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documents: !exists(json, 'documents') ? undefined : json['documents'].map(IndexDocumentFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetDocumentsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        documents: value.documents === undefined ? undefined : value.documents.map(IndexDocumentToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
